import { render, staticRenderFns } from "./MinhasPresencas.vue?vue&type=template&id=563bc196&scoped=true"
import script from "./MinhasPresencas.vue?vue&type=script&lang=js"
export * from "./MinhasPresencas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563bc196",
  null
  
)

export default component.exports